<form class="address" [formGroup]="addressForm" autocomplete="off">
	<label for="street">Calle</label>
	<div class="item-form">
		<i class="bi bi-signpost icon black bg-gray"></i>
		<input
			class="form-control bg-gray"
			type="text"
			id="street"
			name="street"
			placeholder="Ej. Privada de Naranxan"
			formControlName="street"
			[ngClass]="{
				'--invalid': streetField.invalid && streetField.dirty,
				'--valid': streetField.valid && streetField.dirty
			}"
			#street />
	</div>
	<cmv-error-message
		*ngIf="(streetField.touched || streetField.dirty) && streetField.errors"
		class="--invalid-input">
		Este campo es requerido
	</cmv-error-message>

	<div class="address__wrap-input">
		<div>
			<label for="exteriorNumber">No. Exterior</label>
			<div class="item-form">
				<i class="bi bi-house-door icon black bg-gray"></i>
				<input
					class="form-control bg-gray"
					type="text"
					id="exteriorNumber"
					name="exteriorNumber"
					placeholder="Ej. 43"
					formControlName="exteriorNumber"
					[ngClass]="{
						'--invalid':
							exteriorNumberField.invalid && exteriorNumberField.dirty,
						'--valid': exteriorNumberField.valid && exteriorNumberField.dirty
					}"
					#exteriorNumber />
			</div>
			<cmv-error-message
				*ngIf="
					(exteriorNumberField.touched || exteriorNumberField.dirty) &&
					exteriorNumberField.errors
				"
				class="--invalid-input">
				Este campo es requerido
			</cmv-error-message>
		</div>
		<div>
			<label for="interiorNumber">No. interior</label>
			<div class="item-form">
				<i class="bi bi-house-door icon black bg-gray"></i>
				<input
					class="form-control bg-gray"
					type="text"
					id="interiorNumber"
					name="interiorNumber"
					placeholder="Ej. 2B"
					formControlName="interiorNumber" />
			</div>
		</div>
	</div>

	<div>
		<label for="state">Estado</label>
		<div class="address__datalist">
			<cmv-datalist
				[sourceList]="statesOptions"
				inputName="state"
				placeholder="Selecciona tu estado"
				(selected)="onStateChange($event)"></cmv-datalist>
		</div>
		<cmv-loader-message *ngIf="isSearchStatesLoading"
			>Espere, cargando estados</cmv-loader-message
		>
		<cmv-error-message
			*ngIf="(stateField.touched || stateField.dirty) && stateField.errors"
			class="--invalid-input">
			Este campo es requerido
		</cmv-error-message>
	</div>

	<div>
		<label for="city">Ciudad</label>
		<div class="address__datalist">
			<cmv-datalist
				[sourceList]="citiesOptions"
				inputName="city"
				placeholder="Selecciona tu ciudad"
				(selected)="onCityChange($event)"></cmv-datalist>
		</div>
		<cmv-loader-message *ngIf="isSearchCityLoading"
			>Espere, cargando ciudades</cmv-loader-message
		>
		<cmv-error-message
			*ngIf="(cityField.touched || cityField.dirty) && cityField.errors"
			class="--invalid-input">
			Este campo es requerido
		</cmv-error-message>
	</div>

	<div>
		<label for="postalCode">Código postal</label>
		<div class="item-form">
			<i class="bi bi-geo-alt icon black bg-gray"></i>
			<input
				class="form-control bg-gray"
				type="text"
				id="postalCode"
				name="postalCode"
				placeholder="Ej. 58000"
				formControlName="postalCode"
				[ngClass]="{
					'--invalid': postalCodeField.invalid && postalCodeField.dirty,
					'--valid': postalCodeField.valid && postalCodeField.dirty
				}" />
		</div>
		<cmv-error-message
			*ngIf="
				(postalCodeField.touched || postalCodeField.dirty) &&
				postalCodeField.errors
			"
			class="--invalid-input">
			Debe seleccionar una colonia valida
		</cmv-error-message>
	</div>

	<div>
		<label for="colony">Colonia</label>
		<div class="address__datalist">
			<cmv-datalist
				[sourceList]="coloniesOptions"
				inputName="colony"
				placeholder="Ej. Colonia Centro"
				(selected)="onColonySelected($event)"></cmv-datalist>
		</div>
		<cmv-loader-message *ngIf="isSearchColonyLoading">
			Espere, cargando colonias
		</cmv-loader-message>
		<cmv-error-message
			*ngIf="(colonyField.touched || colonyField.dirty) && colonyField.errors"
			class="--invalid-input">
			Este campo es requerido
		</cmv-error-message>
	</div>
</form>
